module.exports = __webpack_public_path__ + "img/icon-ava.1c70c87f.svg";